/* eslint-disable import/prefer-default-export */
import type { ValidationTargetFieldProfiling } from "../types";

export function addTargetField<
	TargetField extends ValidationTargetFieldProfiling,
	Rule extends { targetField: TargetField },
>(targetField: TargetField, rules: Omit<Rule, "targetField">[]): Rule[] {
	return rules.map((rule) => ({ ...rule, targetField })) as Rule[];
}
